<template>
  <fin-add-to-portfolio-display :action="action"
                                :cancel-no-redirect="cancelNoRedirect"
                                :disable-default-submit-navigation="disableDefaultSubmitNavigation"
                                :instruments="instruments"
                                :portfolio-id="portfolioId"
                                :portfolios="loadPortfolios"
                                :title="title"
                                :to="to"
                                :user-id="userId"/>
</template>

<script>
import {finPortfolioAPI} from '@/js/finAPI'
import {mapGetters} from "vuex"
import FinAddToPortfolioDisplay from "@/components/common/portfolio/AddToPortfolio/display"

export default {
  name: 'fin-add-to-portfolio',
  components: {
    FinAddToPortfolioDisplay
  },
  props: {
    /** The instruments to buy | sell */
    instruments: {
      type: Array
    },
    /** The title to display if no action is set */
    title: {
      type: String
    },
    /** Possible actions: buy | sell */
    action: {
      type: String,
      default: ''
    },
    /** The id of the portfolio which is affected by the buy | sell action. When calling this page from a portfolio
     * page, the portfolioId is already known. */
    portfolioId: {
      type: String,
      default: undefined
    },
    /** The navigation after successful buy | sell */
    to: {
      type: Object,
      default: undefined
    },
    /** If set, the cancel click only triggers an emit of addToPortfolioCancel without any redirect */
    cancelNoRedirect: {
      type: Boolean,
      default: false
    },
    /** If set, the submit click only triggers an emit of addToPortfolioDone without any redirect */
    disableDefaultSubmitNavigation: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters('auth', ['userId']),
  },
  methods: {
    async loadPortfolios() {
      if (!this.portfolioId) {
        const portfolios = await finPortfolioAPI.listMinimalPortfolios(this.userId)
        return portfolios.items
      } else {
        const portfolio = await finPortfolioAPI.getMinimalPortfolio(this.portfolioId)
        return [portfolio]
      }
    },
  },
}
</script>

<style scoped>

</style>
